// @flow

export const RESIDENTS_LIST_READY = 'RESIDENTS_LIST_READY'
